import Image from "next/image"

export interface ImageWithTitleProps {
  src: string
  alt: string
  title: string
  variant?: "banner" | "square"
}

const ImageWithTitle = ({ src, alt, title, variant = "banner" }: ImageWithTitleProps) => {
  const wrapperClasses =
    variant === "banner"
      ? "relative w-auto h-[229px] sm:w-auto sm:h-auto sm:aspect-[1200/560] rounded-lg overflow-hidden mx-auto"
      : "w-auto h-[229px] sm:w-auto sm:h-auto sm:max-h-[30rem] sm:aspect-square rounded-lg overflow-hidden mx-auto"

  const titleClasses =
    variant === "banner"
      ? "text-white text-2xl sm:text-[2.5rem] leading-tight sm:leading-[3.375rem] font-bold drop-shadow-lg text-center px-4"
      : "text-white text-xl sm:text-[2.5rem] leading-tight sm:leading-[3.375rem] font-bold drop-shadow-lg text-center px-4"

  return (
    <div className={wrapperClasses}>
      <Image
        fill
        src={src}
        alt={alt}
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
      />
      <div className="absolute inset-0 flex items-center justify-center">
        <h3 className={titleClasses}>{title}</h3>
      </div>
    </div>
  )
}

export default ImageWithTitle
